import { gql } from '@apollo/client/core'

/** QUERIES */
export const GET_PRODUCTS_BY_IDS = gql`
  query getProductsByIds($ids: [ID!]!, $metafieldIdentifiers: [HasMetafieldsIdentifier!]!) {
    nodes(ids: $ids) {
      ... on Product {
        id
        title
        handle
        vendor
        description
        featuredImage {
          url
        }
        priceRange {
          maxVariantPrice {
            amount
          }
        }
        options(first: 5) {
          name
        }
        variants(first: 250) {
          edges {
            node {
              id
              title
              sku
              availableForSale
              currentlyNotInStock
              metafields(identifiers: $metafieldIdentifiers) {
                namespace
                key
                value
              }
              selectedOptions {
                name
                value
              }
              priceV2 {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`

export const GET_PRODUCTS_SKU_BY_IDS = gql`
  query getProductsByIds($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on Product {
        id
        featuredImage {
          url
        }

        variants(first: 250) {
          edges {
            node {
              id
              availableForSale
              sku
            }
          }
        }
      }
    }
  }
`
